import { webApi } from "../../../../core/http/httpThunks";
import { GuaranteeData } from "../types";

export const getGuaranteeApi = (userId: string, payid: string) =>
  webApi<GuaranteeData>({
    method: "GET",
    url: "clearing/getpayment",
    params: {
      userId,
      payid,
    },
  });

export default getGuaranteeApi;
